import { useEffect } from 'react';

const useSocialMeta = ({ title, description, image, url, type = 'website' }) => {
  useEffect(() => {
    if (!title) return;

    // Use window.location.origin to get the current domain dynamically
    const baseUrl = window.location.origin;
    const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
    const fullImageUrl = image ? `${baseUrl}${image}` : null;

    // Update document title
    document.title = `${title} - burnair Academy`;

    // Helper function to update or create meta tags
    const updateMeta = (property, content, isName = false) => {
      const selector = isName ? `meta[name="${property}"]` : `meta[property="${property}"]`;
      let meta = document.querySelector(selector);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (isName) {
          meta.setAttribute('name', property);
        } else {
          meta.setAttribute('property', property);
        }
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Update basic meta tags
    updateMeta('description', description, true);
    
    // Update Open Graph tags
    updateMeta('og:type', type);
    updateMeta('og:url', fullUrl);
    updateMeta('og:title', title);
    updateMeta('og:description', description);
    
    // Only update image if we have one
    if (image) {
      updateMeta('og:image', fullImageUrl);
    }

    // Update Twitter tags
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:url', fullUrl);
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
    
    // Only update image if we have one
    if (image) {
      updateMeta('twitter:image', fullImageUrl);
    }

    // Cleanup function to reset to defaults when component unmounts
    return () => {
      const currentBaseUrl = window.location.origin;
      document.title = 'burnair Academy';
      updateMeta('description', 'A platform for learning about burnair Map, burnair Go and paragliding in general.', true);
      updateMeta('og:title', 'burnair Academy');
      updateMeta('og:description', 'A platform for learning about burnair Map, burnair Go and paragliding in general.');
      updateMeta('og:image', `${currentBaseUrl}/images/burnair-rounded.png`);
      updateMeta('og:url', currentBaseUrl);
      updateMeta('twitter:title', 'burnair Academy');
      updateMeta('twitter:description', 'A platform for learning about burnair Map, burnair Go and paragliding in general.');
      updateMeta('twitter:image', `${currentBaseUrl}/images/burnair-rounded.png`);
      updateMeta('twitter:url', currentBaseUrl);
    };
  }, [title, description, image, url, type]);
};

export default useSocialMeta;